import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, LayoutDashboard } from "lucide-react";

const ADMIN_EMAIL = "chahalsimmi725@gmail.com";

export const UserBadge = () => {
  const { user, signIn, signOut } = useAuth();
  if (!user) {
    return (
      <button
        onClick={signIn}
        data-testid="header-signin-btn"
        className="px-3.5 py-1.5 rounded-full bg-white/80 backdrop-blur border border-borderSoft text-espresso text-xs hover:shadow-glow transition"
      >
        Sign in
      </button>
    );
  }
  const isAdmin = user.email?.toLowerCase() === ADMIN_EMAIL;
  return (
    <div className="flex items-center gap-2 bg-white/80 backdrop-blur border border-borderSoft rounded-full pl-1 pr-2 py-1" data-testid="user-badge">
      {user.picture ? (
        <img src={user.picture} alt={user.name} className="w-7 h-7 rounded-full object-cover" />
      ) : (
        <div className="w-7 h-7 rounded-full bg-blush flex items-center justify-center text-espresso text-xs font-medium">
          {user.name?.[0]?.toUpperCase() || "U"}
        </div>
      )}
      {isAdmin && (
        <Link to="/admin" data-testid="admin-link" aria-label="Admin dashboard"
          className="w-6 h-6 rounded-full flex items-center justify-center text-gold hover:text-goldDeep">
          <LayoutDashboard size={13} />
        </Link>
      )}
      <button
        onClick={signOut}
        data-testid="header-signout-btn"
        aria-label="Sign out"
        className="w-6 h-6 rounded-full flex items-center justify-center text-mocha hover:text-espresso"
      >
        <LogOut size={13} />
      </button>
    </div>
  );
};

export default UserBadge;
